const DEFAULT_VALUE = {
    loanAmount: 10000,
    setLoanAmount(loanAmount: number) {
      this.loanAmount = loanAmount;
    }
};
  
export default DEFAULT_VALUE;